import React, { Component } from 'react';
import Head from 'next/head'
import { SeasonDivisionSelector, Header, Footer, TeamStanding, DivisionPageWrapper } from '../components'
import { fetchDivisions } from '../api/divisions'
import { fetchStandings } from '../api/division-entries'

class TeamStandings extends Component {

  static async getInitialProps({req, query, props}) {
    const standingsPromise = fetchStandings(props.divisionId);
    return {
      standings: await standingsPromise,
      organisationId: props.organisationId
    }
  }

  render() {
    const { divisionId, seasonId, competitionId, divisions, seasons, competitions, standings, organisationId, organisation, pages } = this.props
    const filteredCompetitions = {
      data: competitions.data.filter(c => c.name != 'BRHA Rec')
    }
    let imageSrc="https://brha.co/static/photo.png"

    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | Team Standings `}</title>
          <meta property="og:title" content={`BRHA | Team Standings `} />
          <meta property="og:description" content={`Team Standings`} />
          <meta property="og:image" content={imageSrc} />
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
          <h1>{'Team Standings'}</h1>

          <SeasonDivisionSelector
            baseUrl={`team-standings`}
            seasons={seasons}
            competitions={filteredCompetitions}
            divisions={divisions}
            divisionId={divisionId}
            seasonId={seasonId}
            competitionId={competitionId}/>

          {standings.data.length > 0 &&
            <table>
              <thead>
                <tr>
                  <th>{'Team'}</th>
                  <th className="u-center">
                    <span className="u-show-mobile-landscape">{'P'}</span>
                    <span className="u-hide-mobile-landscape">{'Played'}</span>
                  </th>
                  <th className="u-center u-show-mobile-landscape">{'W'}</th>
                  <th className="u-center u-show-mobile-landscape">{'D'}</th>
                  <th className="u-center u-show-mobile-landscape">{'L'}</th>
                  <th className="u-center u-show-tablet-portrait">{'GF'}</th>
                  <th className="u-center u-show-tablet-portrait">{'GA'}</th>
                  <th className="u-center u-show-mobile-landscape">{'GD'}</th>
                  <th className="u-center">
                    <span className="u-show-mobile-landscape">{'Pts'}</span>
                    <span className="u-hide-mobile-landscape">{'Points'}</span></th>
                </tr>
              </thead>
              <tbody>
                {standings.data.map(s =>
                  <TeamStanding key={s.id} name={s.name} teamId={s.team_id} divisionEntryId={s.id} stats={s.stats} />
                )}
              </tbody>
            </table>
          }
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}

export default DivisionPageWrapper(TeamStandings, false)
